import { KnowMoreButton } from "../home/knowMoreButton";
import "./gallery.css";
import gallery1 from "./gallery1.jpg";
import gallery2 from "./gallery2.jpg";
import gallery3 from "./gallery3.jpg";
import gallery4 from "./gallery4.jpg";
import gallery5 from "./gallery5.jpg";
import gallery6 from "./gallery6.jpg";

export const Gallery = () => {
  return (
    <>
      <section class="gallery">
        <h2>Our Gallery</h2>
        <div class="gallery-container">
          <img src={gallery1} alt="Gallery 1" />
          <img src={gallery2} alt="Gallery 2" />
          <img src={gallery3} alt="Gallery 3" />
          <img src={gallery4} alt="Gallery 4" />
          <img src={gallery5} alt="Gallery 5" />
          <img src={gallery6} alt="Gallery 6" />
        </div>
        <KnowMoreButton text="Contact Us" href="contact" />
      </section>
    </>
  );
};
